export default function WelcomePage() {
  return (
    <div className="text-center mb-4">
      <h1><strong>A Smarter Way to Evaluate Software Developers/Engineers</strong></h1>
      <h3>⚡ No sign-up. No guesswork. Just type a GitHub username and explore.</h3>
    </div>
  );
}
